import {Component, input, output} from '@angular/core';
import {AuthenticatorModel, DeviceAuthenticatorsModel} from "../../../shared/models/authenticator.model";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {TranslatePipe} from "@ngx-translate/core";
import {ColumnMode, NgxDatatableModule, SelectionType} from "@swimlane/ngx-datatable";
import {NgIf} from "@angular/common";
import {TooltipDirective} from "ngx-bootstrap/tooltip";
import {CommonModule} from "../../../common.module";

@Component({
  selector: 'app-other-authenticators',
  standalone: true,
  imports: [
    CommonModule,
    FaIconComponent,
    TranslatePipe,
    NgxDatatableModule,
    NgIf,
    TooltipDirective
  ],
  templateUrl: './other-authenticators.component.html',
  styleUrl: './other-authenticators.component.scss'
})
export class OtherAuthenticatorsComponent {

  deviceAuthenticator = input.required<DeviceAuthenticatorsModel>();
  hideRemoveAuthenticatorsButton = input.required<boolean>();
  iconMapping = input.required<any>();
  adPasswordSelfReset = input.required<boolean>();
  adPasswordSelfRenewal = input.required<boolean>();

  onRemoveAuthenticator = output<any>()
  onLdapReset = output<any>()
  onResetPin = output<void>()


  protected readonly SelectionType = SelectionType;
  protected readonly ColumnMode = ColumnMode;

  removeAuth(row: AuthenticatorModel) {
    this.onRemoveAuthenticator.emit(row);
  }

  resetPin() {
    this.onResetPin.emit();
  }

  resetLdapPassword(ldapMethods: string, row: any) {
    this.onLdapReset.emit({ldapMethod: ldapMethods, row: row})
  }
}
